import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCanvasGrid: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="canvas-grid, design, app-icon, blueprint"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 4V6.5M12 20V17.5M4 12H6.5M20 12H17.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8.5 12H15.5M12 8.5V15.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCanvasGrid;
